// Hosts come from the environment so a local run can be pointed at a local API without editing
// (and later accidentally committing) this file. The defaults are production, so an environment
// with nothing set behaves exactly as before.
//
// .env already carried REACT_APP_API_BASE_URL but nothing read it, so setting it appeared to do
// nothing and the portal kept talking to production.
//
// Include the /api suffix in the value, e.g. https://localhost:7277/api
export const Config = {
  // Production, and it has to stay that way. Create React App inlines REACT_APP_* at build time, so
  // whatever stands here is what ships when the build environment sets nothing - and a build that
  // has silently baked in a developer's machine looks completely normal until a pupil opens their
  // access link. That is what happened: this default was changed to localhost:7277 while testing
  // locally, went out with a release, and every magic link on pupil.welbee.co.uk failed with
  // "Email token verification failed" while the token itself was perfectly valid and the API
  // answered 200 to the same request from anywhere else.
  //
  // Point a local run at a local API through .env, never by editing this line.
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://api.insights.welbee.co.uk/api',
  ADMIN_BASE_URL: process.env.REACT_APP_ADMIN_BASE_URL || 'https://api.admin.welbee.co.uk/api',
  App_Url: process.env.REACT_APP_URL || 'https://pupil.welbee.co.uk',
}
